import { Component } from '@angular/core';

@Component({
  selector: 'app-scanner-mobile',
  templateUrl: './scanner-mobile.component.html',
  styleUrls: ['./scanner-mobile.component.scss'],
})
export class ScannerMobileComponent {}
